import { put, call, takeEvery } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/investorProfile'
import { getInvestorProfile } from 'services'

const { INVESTOR_PROFILE_REQUEST, INVESTOR_PROFILE_SUCCESS, INVESTOR_PROFILE_ERROR } = ACTION_TYPES

export function *investorProfile() {
  try {
    const response = yield call(getInvestorProfile)
    yield put({ type: INVESTOR_PROFILE_SUCCESS, payload: response })
  } catch (err) {
    yield put({ type: INVESTOR_PROFILE_ERROR, payload: err })
  }
}

export default function *watchInvestorProfile() {
  yield takeEvery(INVESTOR_PROFILE_REQUEST, investorProfile)
}
